import nextAction from 'model/actions/utilities/nextAction';

const end = onDone => ({
  title: 'McKenzie Brothers',
  description: [
    'the accused pled innocence bu their words were drowned out by a crescendo of angry shouts and curses',
    'the judge - either convinced of their guilt, or fearing a riot, or both - quickly sentenced them to die on the gallows tree.',
    'ropes were thrown around their necks. they struggled for their lives but what avail was the effort. the townfolk had nothing but hatred for those who called themselves murderers.',
    'the hanged by the neck until dead'
  ],
  buttons: [nextAction('Continue', onDone)]
});

const accused = onDone => ({
  title: 'McKenzie Brothers',
  description: [
    'the brothers, part of a larger gang recently arrived in town, had spent the last week drinking, gambling, whoring and brawling',
    'in between these inspired activities, they were heard talking about having robbed and massacred scores of people from a caravan',
    'women... children... all brutally murdered',
    'a parade of witnesses came forth to testify to overhearing them admit their crimes dozens of times over'
  ],
  buttons: [nextAction('My caravan?', () => onDone(end(onDone)))]
});

const start = onDone => ({
  title: 'McKenzie Brothers',
  description: [
    'the two had barely stirred from their night of drinking, when they were caught',
    'they were dragged to the jailhouse. it was short work.',
    'the trial would begin the same day. an open spectacle with half the town in attendance'
  ],
  buttons: [nextAction('Watch', () => onDone(accused(onDone)))]
});

export default start;
